<template>
	<div class="flex items-center">
		<div class="relative z-50">
			<!-- Profile Button -->
			<button
				@click="isProfileMenuOpen = !isProfileMenuOpen"
				class="flex items-center space-x-3 hover:bg-gray-100 rounded-full p-2"
			>
				<!-- Profile Image -->
				<img
					:src="profileImage"
					:alt="authStore.userProfile?.displayName"
					class="h-8 w-8 rounded-full object-cover"
				/>
				<!-- Name and Chevron -->
				<div class="hidden md:flex items-center space-x-1">
					<span class="text-sm font-medium">
						{{ authStore.userProfile?.displayName }}
					</span>
					<ChevronDownIcon class="h-4 w-4 text-gray-500" />
				</div>
			</button>

			<!-- Dropdown Menu -->
			<div
				v-if="isProfileMenuOpen"
				class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1"
				@click.away="isProfileMenuOpen = false"
			>
				<!-- User Info -->
				<div class="px-4 py-2 border-b">
					<p class="text-sm font-medium text-gray-900">
						{{ authStore.userProfile?.displayName }}
					</p>
					<p class="text-xs text-gray-500">
						{{ authStore.userProfile?.email }}
					</p>
				</div>

				<!-- Menu Items -->
				<RouterLink
					v-for="item in menuItems"
					:key="item.to"
					:to="item.to"
					class="dropdown-item"
					@click="isProfileMenuOpen = false"
				>
					<component :is="item.icon" class="h-4 w-4 mr-2" />
					{{ item.text }}
				</RouterLink>

				<button
					@click="handleLogout"
					class="dropdown-item text-red-600 hover:bg-red-50"
				>
					<ArrowLeftEndOnRectangleIcon class="h-4 w-4 mr-2" />
					Sign Out
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import {
	UserCircleIcon,
	UsersIcon,
	ChevronDownIcon,
	ArrowLeftEndOnRectangleIcon,
} from "@heroicons/vue/24/outline";

const router = useRouter();
const authStore = useAuthStore();
const isProfileMenuOpen = ref(false);

const profileImage = computed(
	() =>
		authStore.userProfile?.photoURL ||
		`https://ui-avatars.com/api/?name=${authStore.userProfile?.displayName}`
);

const menuItems = computed(() => {
	const items = [
		{ to: "/admin/profile", text: "Profile Settings", icon: UserCircleIcon },
	];

	if (authStore.isSuperAdmin) {
		items.push({
			to: "/admin/users",
			text: "User Management",
			icon: UsersIcon,
		});
	}

	return items;
});

const handleLogout = async () => {
	try {
		await authStore.logout();
		router.push("/");
	} catch (error) {
		console.error("Error signing out:", error);
	}
};
</script>

<style scoped>
.dropdown-item {
	@apply flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full;
}
</style>
